/* Animations au défilement, communes à toutes les pages (08/10/2026).
   L'accueil et la page Kit ont leurs propres animations : elles posent data-kx-local et ce script s'arrête.
   Règles : transform et opacité seulement ; rien n'est masqué s'il est déjà à l'écran au chargement ;
   après l'apparition, l'élément retrouve exactement son style d'origine ; tout est coupé si
   « réduire les animations » est activé (la classe kx-anim n'est alors jamais posée). */
(function(){
  var H=document.documentElement;
  if(!H.classList.contains('kx-anim')||H.hasAttribute('data-kx-local')||!('IntersectionObserver' in window))return;
  var vh=window.innerHeight||800;
  function $$(s,r){try{return [].slice.call((r||document).querySelectorAll(s));}catch(e){return [];}}

  var HORS='csm-cookie-consent,.csm-cmp-root,.needsclick,[class*="klaviyo"],[id*="shopify-section-header"],.header,.announce,.mm,.mm-burger__panel,.sc,footer,.footer,.kx-foot,.wa-float,.sr-only,[hidden],.pdp__sticky,.pdp__media,.pdp__buy .pdp__cures,.cx-express,template,dialog';
  var PROSE='.legal__body,.pg__prose,.g__body,.mag-article__body,.rte';

  /* [sélecteur, sens, délai de cascade, cascade max] */
  var plan=[
    ['h2,h3,.h2,[class*="eyebrow"],[class*="kicker"]','',.06,2],
    ['.tcard2,.wrev,.pc,.collection-product,.story-card,.progress-card,.mdl-ugc__card,.sfam__card,.ct__card,.qsn-founder,.fondateur,.mag-rcard,.kx-duoc,.kx-kitc,.bsf__benefit,.hc__group,.g-related,.diff__item,.reassure__item','',.09,4],
    ['.howto__row,.howto__step,.g-list__item,.mrc__step,.kx-boite li','g',.08,5],
    ['.faq__item,.hc__item,.ns-faq__item,.pdp__acc-item','',.05,6],
    ['.ba-compare,[class*="compare"]:not([class*="compare__"]),figure,picture,video,img','z',.08,3],
    ['[class*="__lead"],[class*="lede"],[class*="__intro"],[class*="__txt"],[class*="__text"],[class*="__desc"],section>p,section>div>p,[class*="__note"]','',.06,2,'texte'],
    ['.btn-dark,.results-btn,.nf-btn,.kx-voir,.mdl-next__cta,[class*="__cta"],.kx-rappel__btn,.ct__send,.kx-lien,.kx-plein','z',.06,1],
    ['.pdp__pay-item','',.04,12]
  ];
  var DIR_PAR_SEL={};
  var cibles=[],deja=new Set();
  function exclu(el){
    if(el.closest(HORS))return true;
    if(el.closest('[data-kx-g]'))return true;
    var cs=getComputedStyle(el);
    if(cs.display==='none'||cs.visibility==='hidden'||cs.position==='fixed'||cs.position==='absolute'||cs.position==='sticky')return true;
    if(cs.transform&&cs.transform!=='none')return true;
    if(cs.animationName&&cs.animationName!=='none')return true;
    if(parseFloat(cs.opacity)<.99)return true;
    var r=el.getBoundingClientRect();
    if(r.width<8||r.height<8)return true;
    if(r.top<vh-4)return true; /* déjà à l'écran (ou au-dessus) : on n'y touche pas */
    return false;
  }
  /* Chaque élément prend la première règle qui le concerne ; on parcourt la page dans l'ordre pour animer le bloc parent plutôt que ses enfants. */
  var regle=new Map();
  plan.forEach(function(p){$$(p[0]).forEach(function(el){if(!regle.has(el))regle.set(el,p);});});
  var tous=[];regle.forEach(function(p,el){tous.push(el);});
  tous.sort(function(a,b){return a===b?0:(a.compareDocumentPosition(b)&Node.DOCUMENT_POSITION_FOLLOWING?-1:1);});
  tous.forEach(function(el){
    var p=regle.get(el),t=el.tagName;
    if(t==='IMG'||t==='PICTURE'||t==='VIDEO'){var r0=el.getBoundingClientRect();if(r0.width<140||r0.height<100)return;}
    if(p[4]==='texte'&&el.closest(PROSE))return; /* les longs textes (CGV, guide, articles) restent immobiles */
    if(exclu(el))return;
    el.setAttribute('data-kx-g',p[1]);
    el._kxg=p;deja.add(el);cibles.push(el);
  });
  /* Cascade : délai selon le rang parmi les frères animés. */
  var parParent=new Map();
  cibles.forEach(function(el){var pa=el.parentNode;if(!parParent.has(pa))parParent.set(pa,[]);parParent.get(pa).push(el);});
  parParent.forEach(function(liste){liste.forEach(function(el,i){var p=el._kxg,k=p[3]?Math.min(i,p[3]):i;el.style.setProperty('--kxg-d',(p[2]*k).toFixed(2)+'s');});});

  function montrer(el){
    if(el.classList.contains('kxg-vu'))return;
    el.classList.add('kxg-vu');
    var d=parseFloat(el.style.getPropertyValue('--kxg-d'))||0;
    /* Une fois arrivé, l'élément retrouve son style d'origine (transitions et survols du thème). */
    setTimeout(function(){el.removeAttribute('data-kx-g');el.classList.remove('kxg-vu');},(d+1)*1000);
  }
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){montrer(e.target);io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px',threshold:.12});
  /* Carrousels : toutes les cartes apparaissent ensemble quand le carrousel arrive. */
  var groupes=new Map();
  cibles.forEach(function(el){
    var g=el.parentNode&&el.parentNode.closest&&el.parentNode.closest('.carousel__viewport,[class*="__track"],[class*="__rail"],[class*="__strip"]');
    if(!g){var pa=el.parentNode,cs=pa&&pa.nodeType===1?getComputedStyle(pa):null;if(cs&&(cs.overflowX==='auto'||cs.overflowX==='scroll'))g=pa;}
    if(g){if(!groupes.has(g))groupes.set(g,[]);groupes.get(g).push(el);}else io.observe(el);
  });
  groupes.forEach(function(liste,g){new IntersectionObserver(function(es,o){es.forEach(function(e){if(e.isIntersecting){liste.forEach(montrer);o.disconnect();}});},{threshold:.12}).observe(g);});

  /* Petits détails qui s'animent quand on les voit : étoiles qui se remplissent, icônes et numéros qui sautent, écusson qui se dessine. */
  var details=[];
  function attendre(sel,cls,cascade){
    var parP=new Map();
    $$(sel).forEach(function(el){
      if(el.closest(HORS))return;
      var r=el.getBoundingClientRect();if(r.width<4||r.top<vh-4)return;
      var cs=getComputedStyle(el);if(cs.animationName&&cs.animationName!=='none')return;
      el.classList.add('kxg-attente',cls);
      var pa=el.parentNode&&el.parentNode.parentNode;if(!parP.has(pa))parP.set(pa,0);var i=parP.get(pa);parP.set(pa,i+1);
      if(cascade)el.style.setProperty('--kxg-d',(Math.min(i,5)*cascade+.2).toFixed(2)+'s');
      details.push(el);
    });
  }
  attendre('img.trust-rating__stars,img[src*="etoiles"],.mdl-stars,.wrev__stars,.tcard2__stars','kxg-etoiles',0);
  attendre('.pdp__check,.pdp__atout-coche,.reassure__icon,.howto__icon,.howto__step-num,.ns-faq__num,.mag-icon,.ct__done-mark,.wrev__avatar','kxg-pop',.1);
  attendre('.pdp__guarantee','kxg-trace',0);
  var iod=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){var t=e.target;t.classList.add('kxg-vu');t.classList.remove('kxg-attente');iod.unobserve(t);}});},{rootMargin:'0px 0px -6% 0px',threshold:.3});
  details.forEach(function(el){iod.observe(el);});

  /* Filet de sécurité : après un saut (ancre, défilement très rapide), ce qui est passé au-dessus s'affiche. */
  var attente=null;
  function rattrape(){
    attente=null;var lim=(window.innerHeight||vh)*.9;
    $$('[data-kx-g]:not(.kxg-vu)').forEach(function(el){if(el.getBoundingClientRect().top<lim)montrer(el);});
    $$('.kxg-attente').forEach(function(el){if(el.getBoundingClientRect().top<lim){el.classList.add('kxg-vu');el.classList.remove('kxg-attente');}});
  }
  window.addEventListener('scroll',function(){if(!attente)attente=setTimeout(rattrape,120);},{passive:true});

  /* Boutons d'achat : un reflet les traverse quand ils sont à l'écran (3 fois max), le dernier de la page respire deux fois. */
  var boutons=$$('.pdp__atc,.btn-dark,.results-btn,.kx-rappel__btn,.mdl-next__cta,.nf-btn,[class*="__cta"]').filter(function(el){
    if(el.closest(HORS))return false;var cs=getComputedStyle(el);
    return (cs.position==='static'||cs.position==='relative')&&cs.display!=='inline'&&cs.display!=='none'&&el.getBoundingClientRect().width>80;
  });
  boutons.forEach(function(el,idx){
    el.classList.add('kxg-shine');
    var n=0,t=null,vis=false,souffle=idx===boutons.length-1&&boutons.length>1;
    function briller(){if(!vis||n>=3)return;n++;el.classList.remove('kxg-brille');void el.offsetWidth;el.classList.add('kxg-brille');t=setTimeout(briller,5000);}
    new IntersectionObserver(function(es){es.forEach(function(e){vis=e.isIntersecting;clearTimeout(t);if(vis){t=setTimeout(briller,650);if(souffle){souffle=false;setTimeout(function(){el.classList.add('kxg-souffle');},1700);}}});},{threshold:.85}).observe(el);
  });

  /* Survol sur ordinateur : les cartes se soulèvent légèrement. */
  $$('.tcard2,.wrev,.pc,.story-card,.mdl-ugc__card,.sfam__card,.mag-rcard,.kx-duoc,.ct__card').forEach(function(el){
    var cs=getComputedStyle(el);if(cs.transform==='none')el.classList.add('kxg-carte');
  });
})();
